import { svgIcon } from "@bitwarden/components";

export const TOTPIcon = svgIcon`
<svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="62"
    fill="none"
    class="tw-text-primary-600"
    role="img"
    aria-label="[title]"
  >
    <title>TOTP Authenticator</title>
    <rect width="35" height="12" x="50.324" y="21.5" stroke="currentColor" rx="6" />
    <circle cx="55.324" cy="27.5" r="1.5" fill="currentColor" />
    <circle cx="65.324" cy="27.5" r="1.5" fill="currentColor" />
    <circle cx="75.324" cy="27.5" r="1.5" fill="currentColor" />
    <circle cx="60.324" cy="27.5" r="1.5" fill="currentColor" />
    <circle cx="70.324" cy="27.5" r="1.5" fill="currentColor" />
    <circle cx="80.324" cy="27.5" r="1.5" fill="currentColor" />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M52.703 61h34.706"
    />
    <path
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="2"
      d="M63.932 51.166V61M75.16 51.166V61"
    />
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M38.952 51.166h64.894a6 6 0 0 0 6-6V7a6 6 0 0 0-6-6h-68a6 6 0 0 0-6 6v7.655"
    />
    <path
      stroke="currentColor"
      d="M38.692 46.517h62.999a4 4 0 0 0 4-4V9.552a4 4 0 0 0-4-4H38.537a4 4 0 0 0-4 4v5.103"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M32.284 27.382h11.064l-2.912-2.895M43.348 30.276H32.284l2.912 2.895"
    />
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M37.846 27.75V19a4 4 0 0 0-4-4h-18a4 4 0 0 0-4 4v38a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4V30.5"
    />
    <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M24.806 18.5h.08" />
    <path stroke="currentColor" d="M24.846 36a8 8 0 1 0 7.858 6.5" />
    <path
      fill="currentColor"
      d="M21.547 45.36h1.02v-3.64l-1.221.584v-.626l1.215-.575h.657v4.258h1.007v.545h-2.678v-.545ZM25.793 45.358h2.23v.548h-2.948v-.548c.405-.424.76-.799 1.063-1.124a27 27 0 0 0 .627-.687c.216-.263.363-.475.438-.636.076-.164.114-.33.114-.5 0-.27-.08-.48-.24-.633-.158-.153-.376-.23-.653-.23a1.99 1.99 0 0 0-.621.107 3.493 3.493 0 0 0-.69.323v-.658c.224-.106.443-.185.657-.24.217-.053.43-.08.64-.08.475 0 .856.126 1.145.378.29.25.435.578.435.984 0 .207-.049.413-.146.62a3.005 3.005 0 0 1-.468.684c-.122.14-.298.334-.53.581-.23.248-.58.618-1.053 1.11Z"
    />
  </svg>
`;
